export default __webpack_public_path__ + "static/media/health2.729be211.svg";